<template>
    <el-drawer v-model="vipshow" size="22%" direction="rtl" :before-close="handleClose">
        <el-form inline="true">
            <el-form-item class="top20">
                <label class="TTL-form-label">vip有效期时间</label>
                <wctime :option="{placeholder:'请选择时间',format:'YYYY-MM-DD HH:mm',ischange:true,type:'datetime',clearable:true}" 
                    :value="vipinfo.expire_time" 
                    @finish="(val) => {
                        vipinfo.expire_time = val.value;
                    }"
                />
            </el-form-item>
            <el-form-item class="top10">
                <wcbutton :option="{title:'提交'}" @finish="(val)=> {editVipTime()}" />
            </el-form-item>
        </el-form>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {
    props:['view','data','memberid'],
    data() {
        return {
            vipshow:false,
            vipmemberid:'',
            vipinfo:{}
        }
    },
    watch: {
        view(val){
            if(val) {
                this.vipshow=true;
                this.vipmemberid=this.memberid;
                this.vipinfo=this.data;    
            }
        },
    },
    mounted() {
        
    },
    methods: {

        /** 关闭窗口 **/
        handleClose() {
            this.vipshow=false;
            this.$emit('finish');
        },


        /** 手动修改vip时间 **/
        editVipTime() {
            var param={id:this.vipmemberid,vip_expire_time:this.vipinfo.expire_time};
            INTERFACE_MODEL_MEMBER.EDIT_MEMBER_VIP(param).then((res) => {
                 if(res.status > 0) return false;
                 this.handleClose();
            });
        },


    },
}
</script>
<style scoped>

</style>